import dynamic from 'next/dynamic';
import { mapboxService } from '../../services'
import { serverLocationDetector } from '../../utils/locationDetector';
const DispensariesMap = dynamic(() => import('../../templates/DispensariesMap'))
const Layout = dynamic(() => import('../../components/_App/Layout'))


const fetchGeocoding = async (viewport, types) => {
    try{
        let response = await mapboxService.reverseGeocoding(viewport.longitude, viewport.latitude, types)
        return response
    } catch(err) {
        console.log(err.message)
    }
}


export default function Dispensaries({viewport, place, updateUrl, updateUrlAs, locationInfo, isAppleMobile}){
    return (
        <Layout
            isAppleMobile = {isAppleMobile} 
            
            seo={{
                description: `Find licensed cannabis dispensaries and delivery services near you.`,
                image: '/static/icons/favicon.png',
                title: 'Cannabis Dispensaries & Delivery Services Near Me | Weedzly',
                url:'https://weedzly.com/library'
            }}
            excludeFooter = {true}
        >
            
            <DispensariesMap 
                viewport={viewport}
                place={place}
                updateUrl={updateUrl}
                updateUrlAs={updateUrlAs}
                locationInfo={locationInfo}
            />
        </Layout>
    )
}

export async function getServerSideProps(context){
    
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

    let location = await serverLocationDetector(context)


    let viewport = {
        latitude: 33.935351,
        longitude: -118.222528,
        zoom: 11,
        bearing: 0,
        pitch: 0,
        boundingRadius: 8140
    }

    if(location){
        viewport = Object.assign(viewport, location)
    }

    // let locationInCache = locationStringifyFromCookies(context, {object: true})

    // viewport = Object.assign(viewport, locationInCache)

    try {

        let place = await fetchGeocoding({
            latitude: viewport.latitude, 
            longitude: viewport.longitude, 
        }, 'types=place&types=region')

        
   
        return {
            props: {
                // items, 
                isAppleMobile,
                viewport,
                locationInfo: place.features,
                updateUrlAs: `/map`,
                updateUrl: `/map`
            }
        } 
    } catch(err) {
        console.log(err.message)
    }
}